import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

@Injectable()
export class ProviderPayersODataService extends ODataService<IModelBase> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ProviderPayers'
  }
}
